import React, { useRef } from "react";
import { DEFAULT_SIGNATURE_HEIGHT, DEFAULT_SIGNATURE_WIDTH, DEFAULT_STROKE_WEIGHT, SignatureCustomControlProps } from "../../Utils/Interfaces";
import SignatureCanvas from "react-signature-canvas";

// TODO add a stroke width parameter then convert DG initials to use this too
const Signature = (props: SignatureCustomControlProps): JSX.Element => {
    const ref = useRef<SignatureCanvas>(null);

    const canvasOnChange = (): void => {
        const encodedSignature = ref?.current ? ref.current.toDataURL() : "";
        props.mergeChanges(props.sourceId, { signature: encodedSignature });
    };

    if (props.initialValue === "CLEAR") {
        ref?.current?.clear();
    }

    return (
        <SignatureCanvas
            ref={ref}
            onEnd={canvasOnChange}
            minWidth={(props.strokeWeight ?? DEFAULT_STROKE_WEIGHT) * 0.5}
            maxWidth={props.strokeWeight ?? DEFAULT_STROKE_WEIGHT}
            canvasProps={{
                width: props.width ?? DEFAULT_SIGNATURE_WIDTH,
                height: props.height ?? DEFAULT_SIGNATURE_HEIGHT,
                className: "SignatureBox",
            }}
        />
    );
};

export default Signature;
